import { combineReducers } from 'redux';
import documentTypes from './ducks/document-types';
import expiredManualForms from './ducks/expired-manual-forms';
import globalLoader from './ducks/global-loader';

const rootReducer = combineReducers({
  documentTypes,
  expiredManualForms,
  globalLoader,
});

export default rootReducer;
